module.exports = __webpack_public_path__ + "img/mapalunacentro.d3f813cf.jpg";